import { brandAssets } from '../lib/brand-assets.js';
import { APP_VERSION } from '../config.js';
import { PairingBackdrop } from './pairing/PairingBackdrop.js';
import { PairingConnected } from './pairing/PairingConnected.js';
import { PairingWaiting } from './pairing/PairingWaiting.js';
import '../styles/pairing/index.css';

type PairingScreenProps = {
  sessionCode: string | null;
  sessionExpiresAt: string | null;
  sessionError: string | null;
  deviceCode: string | null;
  confirming: boolean;
  connected: boolean;
  connectedScreenName: string | null;
  busy: boolean;
  error: string | null;
  onSubmit: (code: string) => Promise<void>;
  onClearError: () => void;
  onRefreshSession: () => void;
};

/**
 * Player Pairing v5 — full-bleed kiosk connect UI.
 * @see Ghost Screen - Player Pairing v5.dc.html
 */
export function PairingScreen({
  sessionCode,
  sessionExpiresAt,
  sessionError,
  deviceCode,
  confirming,
  connected,
  connectedScreenName,
  busy,
  error,
  onSubmit,
  onClearError,
  onRefreshSession,
}: PairingScreenProps) {
  return (
    <section className="pairing-v5" aria-label="Device pairing">
      <PairingBackdrop />
      <div className="pairing-v5__veil" aria-hidden />

      <header className="pairing-v5__header">
        <img
          className="pairing-v5__logo"
          src={brandAssets.wordmark}
          alt="GhostScreen"
          draggable={false}
        />
      </header>

      {connected ? (
        <PairingConnected
          screenName={connectedScreenName ?? 'Screen connected'}
          locationLabel={null}
        />
      ) : (
        <PairingWaiting
          sessionCode={sessionCode}
          sessionExpiresAt={sessionExpiresAt}
          sessionError={sessionError}
          confirming={confirming}
          busy={busy}
          error={error}
          onSubmit={onSubmit}
          onClearError={onClearError}
          onRefreshSession={onRefreshSession}
        />
      )}

      <footer className="pairing-v5__footer">
        <span>
          Need help? Visit{' '}
          <a href="https://www.ghostscreens.com/compatibility" target="_blank" rel="noreferrer">
            ghostscreens.com/help
          </a>
        </span>
        {deviceCode ? (
          <span>
            Player {deviceCode} · v{APP_VERSION}
          </span>
        ) : null}
      </footer>
    </section>
  );
}
